module.exports = __webpack_public_path__ + "img/svg/background-game-header.45ce1599176b8055c4e973871f984659.svg";